import { AvatarGroupModule } from 'primeng/avatargroup';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { NgModule } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { UserActionsComponent } from './user-actions.component';

@NgModule({
  declarations: [UserActionsComponent],
  imports: [
    CommonModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    ButtonModule,
    DividerModule,
    DrawerModule,
    MegaMenuModule,
    MenuModule,
    TieredMenuModule,
    MenubarModule,
    ToastModule,
  ],
  exports: [UserActionsComponent],
})
export class UserActionsModule {}
